export default class PermissionService {
  static hasPermission (from, to, next) {
    console.log('access control');
    next();
  }
}
